<template>
    <div v-if="visible" :class="['snackbar', error ? 'red_error' : '']">
      <span class="snackbar_text pl-0">
        <v-icon :class="iconClass" :color="iconColor" class="mr-2" />
        <span class="snackbar_text_massage">{{ message }}</span>
      </span>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      message: {
        type: String,
        required: true
      },
      visible: {
        type: Boolean,
        default: true
      },
      error: {
        type: Boolean,
        default: false
      }
    },
    computed: {
    iconClass() {
      return this.error ? 'mdi mdi-alert-circle-outline' : 'mdi mdi-check-circle-outline';
    },
    iconColor() {
      return this.error ? '#FF0000' : '#006CEA';
    }
  }
  };
  </script>

<style >
.snackbar {position: absolute;top: 20px;right: 20px;width: 300px;height: 50px;border-top: 3px solid #006CEA;padding: 12px;background: #fff;display: flex; box-shadow: 0px 0px 6px #c3c3c3;}
.snackbar_text {flex: 1;}
.snackbar_text_massage { width: 250px; }
.snackbar.red_error {
  border-top: 3px solid #F24545;
}
</style>